import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { from as fromPromise, Observable, SchedulerLike } from 'rxjs/index';
import { queue } from 'rxjs/internal/scheduler/queue';
import { map, shareReplay } from 'rxjs/operators';
import { LoadingIndicator } from '../../shared/loading-indicator';
import { BackendAPIService } from '../../core/backend-api.service';
declare var require: any; // Hack to suppress error: Cannot find name 'require'.
const Rx = require('rxjs/index');

/**
 * This is based on account.service.js but only stuff relating to accountsettings in Central
 * and backend requests to AccountSettingsServlet.
 */
@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class AccountSettingService {

    constructor(private httpClient: HttpClient) {
    }

    public getAccountSettingsByUserId(userId: number): Observable<any> {
        return this.httpClient
            .get(`/servlets/central/accounts/${userId}/`, {observe: 'body'});
    };

}
